<template>
<div class="header-logo">
  <img src="https://firebasestorage.googleapis.com/v0/b/producer-feedback.firebasestorage.app/o/BASE%2Fecho-logo_v2.svg?alt=media&token=51106614-9e53-474c-832f-bf7e195e0439"
       alt="Echo Logo"/>
  <p>
    Pre-production Checklist
    <span class="beta-box">beta</span>
  </p>
</div>
  <div class="external-checklist-container">
    <div class="password-prompt save-section" v-if="!verified">
  <h2>This checklist is password protected.</h2><p>Please enter the password to view the content.</p>
  <input type="password" v-model="inputPassword" placeholder="Enter password" />
  <button @click="verifyPassword">Submit</button>
  <p v-if="passError" class="error">{{ passError }}</p>
</div>
    <!-- Once verified, show the checklist content -->
    <div v-else class="flex-container">
      <!-- Left Column: Message -->
    <div class="message-column">
      <div class="hey-text">
        <p>Hey <strong>{{ producerName }}</strong>,</p>
      </div>
      <p><br><strong>{{ sentBy }}</strong> has sent you this checklist to help ensure the Production team has everything they need to get started on your project.
      </p>
        <div class="project-name-orange">{{ projectName }}</div>
    </div>
    
    <!-- Right Column: Checklist Items -->
    <div class="checklist-column">
      <h2>Teamwork Card Checklist</h2>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-brief'" v-model="teamworkCard.briefInDescription" true-value="Yes" false-value="No" />
          <label :for="'cb-brief'" class="check-box"></label>
        </div>
        <span>Brief in description</span>
      </div>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-deadline'" v-model="teamworkCard.deadline" true-value="Yes" false-value="No" />
          <label :for="'cb-deadline'" class="check-box"></label>
        </div>
        <span>Deadline</span>
      </div>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-designer'" v-model="teamworkCard.twAssigned" true-value="Yes" false-value="No" />
          <label :for="'cb-designer'" class="check-box"></label>
        </div>
        <span>Designer assigned</span>
      </div>

      <h2>Creative Checklist</h2>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-preprod'" v-model="creative.preProdQC" true-value="Yes" false-value="No" />
          <label :for="'cb-preprod'" class="check-box"></label>
        </div>
        <span>Pre-production QC</span>
      </div>
      <div class="note-grey">
          <p>Make sure to only use creatives and copy after QC approval</p>
        </div>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-pdf'" v-model="creative.creativePDF" true-value="Yes" false-value="No" />
          <label :for="'cb-pdf'" class="check-box"></label>
        </div>
        <span>Creative routes and/or reference</span>
      </div>
      <div class="note-grey">
          <p>PDF, XD, reference video and/or images. Make sure to include all routes and social variations for the Designers</p>
        </div>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-assets'" v-model="creative.creativeAssets" true-value="Yes" false-value="No" />
          <label :for="'cb-assets'" class="check-box"></label>
        </div>
        <span>Creative assets</span>
      </div>
      <div class="note-grey">
          <p>Working files: images, videos, QR-codes and/or previous project files</p>
        </div>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-copy'" v-model="creative.copy" true-value="Yes" false-value="No" />
          <label :for="'cb-copy'" class="check-box"></label>
        </div>
        <span>Copy</span>
      </div>
      <div class="note-grey">
          <p>QC-approved headlines, legals and anything text related</p>
        </div>
      
      <div class="checkbox-item">
        <div class="checkbox-wrapper-19">
          <input type="checkbox" :id="'cb-deliverables'" v-model="creative.deliverablesList" true-value="Yes" false-value="No" />
          <label :for="'cb-deliverables'" class="check-box"></label>
        </div>
        <span>Deliverables list</span>
      </div>
      <div class="note-grey">
          <p>Excel or in description. Make sure to include all routes, soial variations, platforms, ratio and resolution</p>
        </div>
      
      <!-- Save button at the bottom -->
      <div class="save-section">
        <button @click="saveChecklist">Update Checklist</button>
        <p v-if="successMessage" class="success">{{ successMessage }}</p>
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import ExternalChecklistLogic from "./ExternalChecklistLogic";

export default {
  name: "ExternalChecklist",
  mixins: [ExternalChecklistLogic],
  methods: {
    async saveChecklist() {
      try {
        // Save top-level details, creative and teamworkCard sub-documents
        await this.saveTopLevel();
        await this.saveCreative();
        await this.saveTeamworkCard();
        this.successMessage = "Checklist saved successfully.";
        setTimeout(() => {
          this.successMessage = "";
        }, 3000);
      } catch (err) {
        console.error("Error saving checklist:", err);
      }
    }
  }
};
</script>

<style scoped>
.header-logo {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 3rem;
  }
  .header-logo img {
    height: 80px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .header-logo p {
    font-weight: 800;
    color: #111827;
    margin-top: 0.5rem;
  }

  .beta-box {
  display: inline-block;
  position: relative;
    top: -1px;
  background-color: #EA845A;
  color: #000000;
  padding: 2px 6px;
  margin-left: 5px;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 7px;
}

.password-prompt {
  width: 100%;
  text-align: center;
}

.password-prompt input[type="password"] {
  padding: 0.5rem;
  margin: 1rem 0;
  font-size: 1rem;
}

.flex-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 2rem;
  align-items: flex-start;
  width: 100%;
}

.external-checklist-container {
  max-width: 950px;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  gap: 2rem;
  padding: 3rem 0rem 0rem 0rem;
  align-items: flex-start;
}
.hey-text {
  font-size: 2rem;
  margin-bottom: -2.5rem;
  margin-top: 0;
}
.project-name-orange {
  font-weight: bold;
  color: #EA845A;
}
.note-grey {
  font-size: 0.8rem;
    color: #adadad;
    margin-left: 9px;
    margin-top: -30px;
    margin-right: 65px;
}

.message-column {
  flex: 1;
  min-width: 400px;
  padding-right: 1rem;
  margin-bottom: 30px;
}

.checklist-column {
    padding: 40px 40px 40px 60px;
    background-color: #ffffff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 4px #c9bf9b54;
    border-radius: 30px;
    font-family: "Poppins", sans-serif;
    color: #EA845A;
    max-width: 450px;
    flex: 2;
    min-width: 300px;
}

.checkbox-item {
    display: flex;
    margin-bottom: 2rem;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row-reverse;
    flex-wrap: wrap;
}

.checkbox-item span {
  font-weight: 800;
  color: #000000;
  font-size: 25px;
  margin-left: 0.5rem;
  font-size: 1rem;
}

.checkbox-item label {
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.checkbox-item input[type="checkbox"] {
  margin-right: 0.5rem;
}

.save-section {
  margin-top: 2.5rem;
  text-align: center;
}

.save-section button {
    padding: 10px 20px 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    background-color: #EA845A;
    border: 1px solid #C06C4A;
    box-shadow: inset 0px 2px 3px 0px #FFB681, 0px 2px 3px 0px #FFB681;
    border-radius: 15px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-decoration: none;
}

.save-section button:hover {
  background-color: #ff8d5c;
}
.save-section input[type="password"] {
  width: 200px;
    padding: 10px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 3px 3px #dacb9754;
    border-radius: 15px;
    outline: none;
    font-size: 1rem;
    margin-right: 10px;
}

.success {
  color: green;
  margin-top: 1rem;
}

.error {
  color: red;
  margin-top: 1rem;
}

/* Custom checkbox design */
.checkbox-wrapper-19 {
  box-sizing: border-box;
  --background-color: #fff;
  --checkbox-height: 25px;
}

@keyframes dothabottomcheck-19 {
  0% { height: 0; }
  100% { height: calc(var(--checkbox-height) / 2); }
}

@-webkit-keyframes dothabottomcheck-19 {
  0% { height: 0; }
  100% { height: calc(var(--checkbox-height) / 2); }
}

@keyframes dothatopcheck-19 {
  0% { height: 0; }
  50% { height: 0; }
  100% { height: calc(var(--checkbox-height) * 1.2); }
}

@-webkit-keyframes dothatopcheck-19 {
  0% { height: 0; }
  50% { height: 0; }
  100% { height: calc(var(--checkbox-height) * 1.2); }
}

.checkbox-wrapper-19 input[type="checkbox"] {
  display: none;
}

.checkbox-wrapper-19 .check-box {
  height: var(--checkbox-height);
  width: var(--checkbox-height);
  background-color: transparent;
  border: calc(var(--checkbox-height) * 0.1) solid #000;
  border-radius: 5px;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  transition: border-color ease 0.2s;
  cursor: pointer;
}

.checkbox-wrapper-19 .check-box::before,
.checkbox-wrapper-19 .check-box::after {
  box-sizing: border-box;
  position: absolute;
  height: 0;
  width: calc(var(--checkbox-height) * 0.2);
  background-color: #EA845A;
  display: inline-block;
  transform-origin: left top;
  border-radius: 5px;
  content: " ";
  transition: opacity ease 0.5;
}

.checkbox-wrapper-19 .check-box::before {
  top: calc(var(--checkbox-height) * 0.72);
  left: calc(var(--checkbox-height) * 0.41);
  box-shadow: 0 0 0 calc(var(--checkbox-height) * 0.05) var(--background-color);
  transform: rotate(-135deg);
}

.checkbox-wrapper-19 .check-box::after {
  top: calc(var(--checkbox-height) * 0.37);
  left: calc(var(--checkbox-height) * 0.05);
  transform: rotate(-45deg);
}

.checkbox-wrapper-19 input[type="checkbox"]:checked + .check-box,
.checkbox-wrapper-19 .check-box.checked {
  border-color: #EA845A;
}

.checkbox-wrapper-19 input[type="checkbox"]:checked + .check-box::after,
.checkbox-wrapper-19 .check-box.checked::after {
  height: calc(var(--checkbox-height) / 2);
  animation: dothabottomcheck-19 0.2s ease 0s forwards;
}

.checkbox-wrapper-19 input[type="checkbox"]:checked + .check-box::before,
.checkbox-wrapper-19 .check-box.checked::before {
  height: calc(var(--checkbox-height) * 1.2);
  animation: dothatopcheck-19 0.4s ease 0s forwards;
}
</style>
